import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Opt-in mobile DevTools: enable with `?debug=1` in the URL. Loads eruda from
// a CDN — a floating debug console with Console/Network/Elements/Resources
// tabs that works on any mobile browser. Regular users never see this; it's
// only for support/debug sessions when you want to inspect a specific device.
try {
  const shouldLoadEruda = (() => {
    if (typeof window === 'undefined') return false;
    if (window.location.search.includes('debug=1')) {
      try { localStorage.setItem('sam247_debug', '1'); } catch { /* noop */ }
      return true;
    }
    if (window.location.search.includes('debug=0')) {
      try { localStorage.removeItem('sam247_debug'); } catch { /* noop */ }
      return false;
    }
    try { return localStorage.getItem('sam247_debug') === '1'; } catch { return false; }
  })();
  if (shouldLoadEruda) {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/eruda@3.0.1/eruda.min.js';
    s.onload = () => { try { window.eruda?.init(); } catch { /* noop */ } };
    document.head.appendChild(s);
  }
} catch { /* noop */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
